import { css, Global } from "@emotion/react";
import styled, { keyframes } from "styled-components";
import theme from "@theme";

// Global styles
const globalStyles = css`
  .ant-input-borderless.ant-input-disabled,
  .ant-input-borderless[disabled] {
    color: inherit !important;
  }

  .ant-input-outlined.ant-input-disabled,
  .ant-input-outlined[disabled] {
    background-color: #fff !important;
    color: #000 !important;
  }
`;

// Keyframes for drop animation
const dropAnimation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Wrapper for input and hover overlay positioning
const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

// Overlay that appears on hover, with animation
const Overlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 80%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  animation: ${dropAnimation} 0.5s forwards;
  z-index: 1200;

  ${Wrapper}:hover & {
    opacity: 1;
  }
`;

// Action items in the overlay (icons)
const ActionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.themeColor};
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: ${theme.colors.themeColor};
  }
`;

const SC = {
  GlobalStyles: <Global styles={globalStyles} />,
  Wrapper,
  Overlay,
  ActionItem,
};
export default SC;
